import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../Translations';
import ModalStore from '../../../../../../../../Modal/Store';
import { ExperienceResources } from '../../../../../../../Types';

interface Props {
  modalStore: ModalStore;
  experiences: ExperienceResources;
}
const IncludedExperiences: React.FC<Props> = ({ experiences, modalStore }) => (
  <div className="pr-4">
    <h3 className="text-gray-700 text-sm">
      <T kind="Programs" />
    </h3>
    <div
      className="flex flex-wrap text-teal-600 font-semibold text-lg"
      onClick={modalStore.open}
      data-intercom-target="learning-design-count"
    >
      {experiences.length}
    </div>
  </div>
);

export default observer(IncludedExperiences);
